import React, { useEffect, useState } from 'react';

import Input from 'b2b-ui-components-lib/lib/components/input';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import CustomerMessageCard from '../../customerMessageCard/customerMessageCard';
import Comments from './comments/comments';
import Button from 'b2b-ui-components-lib/lib/components/button';
import AttachmentFiles from './attachment-files/attachment-files';
import './kamview.scss';
import { getLead } from 'home/view/manage-feasibility/services/multiSite-service';
import { getClarityHistory, submitClarity, submitKamOrder } from 'common/helper/api.helper';
import { DOA_STATUS, getInfoContent, KAM_MESSAGE, KAM_META_DATA, TOAST_TYPE, isUserTypeIsKAM } from '../configure-plan-pricing-constant';
import { formateDateToLocaleStringWithTime, getFromSessionStorage, handleError, isNull } from 'common/utils/app.utils';
import { LEAD_STATUS, MODULE_ID, PNQ_AUTHORIZATION_HEADER } from 'home/common/constants/constants';
import PlanPricingLoader from './plan-pricing-loader/planPricingLoader';
import { getStatus, prepareRequestForKAM, saveKAM_META_DATA } from './kamView.service';
import { useInterval } from 'home/view/manage-feasibility/utils';
import { MULTI_SITE_MODULE_ID } from 'home/view/manage-feasibility/constants';
import { saveLead } from 'tokenGeneration/lead.util';

export const KamView = ({ feasibleSite, setToast, showCancelPopUp, setInfoContent, SetBlockJourney, reFetch, displayOneTime, lineItems }) => {
  const [status, setStatus] = useState({ message: '', cssClass: '', toastType: '', disabledAction: false, isPriceZero: false });
  const [commentText, setCommentText] = useState('');
  const [leadData, setLeadData] = useState({});
  const [attachments, setAttachment] = useState(null);
  const onComment = (text) => setCommentText(text);
  const [commentHistory, setCommentHistory] = useState([]);
  const [doPolling, setDoPolling] = useState(false);
  const [loader, setLoader] = useState(false);

  const getHistory = (doaId) => {
    if (doaId) {
      let params = { doaId };
      getClarityHistory(params)
        .then(({ data: { result } }) => {
          if (Array.isArray(result)) {
            setCommentHistory(result);
          }
        })
        .catch((err) => {});
    }
  };

  const onFileUploaded = (filesInfo) => {
    if (Array.isArray(filesInfo)) {
      const fileAttachements = filesInfo
        .filter(({ isUploaded }) => isUploaded)
        .map(({ content, file }) => {
          return { name: file.name, file: content.split(',')[1] };
        });
      setAttachment(fileAttachements);
    }
  };

  const onCancel = () => {
    showCancelPopUp(true);
  };

  const getCustomerRemarks = ({ remarks }) => {
    if (Array.isArray(remarks) && remarks.length > 0) {
      const remark = remarks.find((remark) => remark.userType === 'CUSTOMER');
      return remark ? ` ${formateDateToLocaleStringWithTime(remark.submitAt)} : ${remark.remarks}` : '';
    }
  };

  const onSubmit = () => {
    setLoader(true);
    const request = prepareRequestForKAM(leadData, { commentText, attachments });
    const pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
    const action = leadData.doaStatus === DOA_STATUS.CLARITY_REQUIRED ? DOA_STATUS.CLARITY_SUBMITTED : 'KAM_SUMBIT';
    const submitAPI = leadData.doaStatus === DOA_STATUS.CLARITY_REQUIRED ? submitClarity(request, pnqToken) : submitKamOrder(request, pnqToken);
    submitAPI
      .then((res) => {
        let leadStatusData = res && res.data && res.data.result && res.data.result.leadStatus;
        if (leadStatusData === DOA_STATUS.PRICING_APPROVAL_REQUEST_SENT) setToast(true, KAM_MESSAGE.DOA_PRICING_APPROVAL, TOAST_TYPE.SUCCESS);
        saveKAM_META_DATA({ lastAction: action });
        fetchLead();
        setAttachment(null);
        setLoader(false);
      })
      .catch((err) => {
        handleError(err);
        setLoader(false);
      });
  };

  const fetchLead = (isDoingPolling = false) => {
    const pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);

    if (isUserTypeIsKAM() && isNull(pnqToken)) {
      return false;
    }

    setCommentText('');
    getLead().then(
      ({ data: { result } }) => {
        if (result) {
          setLeadData(result);
          // update journey for KAM
          saveLead(result);

          const { pricingAndQuotationId, status: statusInfo, doaStatus, leadStatus, doaId, totalPrice, totalArcPrice } = result;
          const status = getStatus(result, lineItems);
          getHistory(doaId);
          if (displayOneTime) {
            setInfoContent(getInfoContent());
            if (doaStatus && doPolling) {
              setToast(true, status.message, status.toastType);
            }
          }
          setStatus(status);
          const KAMInfo = getFromSessionStorage(MULTI_SITE_MODULE_ID, KAM_META_DATA) || {};

          saveKAM_META_DATA({ ...KAMInfo, doaStatus });

          setDoPolling(status.doPolling);
          if (status.disabledAction) {
            SetBlockJourney(true);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const isSubmitDisabled = () => {
    return loader || commentText.length < 1 || (status && status.disabledAction) || (status && status.disabledSumbit) || !(leadData && leadData.price && leadData.price.finalPrice);
  };

  useInterval(
    () => {
      fetchLead(true);
    },
    doPolling ? 100000 : null
  );

  useEffect(() => {
    fetchLead(false, reFetch);
  }, [feasibleSite, reFetch]);

  return (
    <React.Fragment>
      {Object.keys(leadData).length > 0 ? (
        <div className="negotiation_section">
          <div className="orderSection">
            <div class="accordion-card">
              <div class="accordion-content">
                <CustomerMessageCard customerRemarks={getCustomerRemarks(leadData)} />
              </div>
            </div>
            <div className="accordion-card">
              <div className="orderSummary">
                <h2 className="summary-head">Plan Pricing And Negotiation</h2>

                <div className="negotiation_card">
                  <div className="accordion-content">
                    <div className="changes_field">
                      <div className="row">
                        <div className="flg-lg-2 flg-md-4">
                          <Input label="Annual Recurring Charges" value={`₹ ${leadData.totalArcPrice}`} required disabled />
                        </div>
                        <div className="flg-lg-2 flg-md-4">
                          <Input label="One-time Charges" value={`₹ ${leadData.totalOtcPrice}`} required disabled />
                        </div>
                        {/* <div className="flg-lg-2 flg-md-4">
                        <Input
                          label="Contract Period"
                          value={Math.floor(leadData.contractPeriod / 12)}
                          required
                          disabled
                        />
                      </div> */}
                      </div>
                    </div>
                    <div className="charges_details">
                      <h6>
                        Total Charges of {feasibleSite} feasible sites (without tax): <strong>&#8377; {leadData.totalPrice}</strong>
                      </h6>
                      <p>GST rates as applicable</p>
                    </div>
                    <div className="comment_box">
                      <p>Add a comment and attachments for customized pricing if any.</p>
                      <div className="textarea_field">
                        <TextArea label="Reason for customised price" placeholder="Enter Description" onChange={onComment} value={commentText} maxLength={250} required />
                      </div>
                      {((leadData && leadData.doaStatus === DOA_STATUS.CLARITY_REQUIRED) || (leadData && leadData.leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION)) && (
                        <div className="attachment_section">
                          <AttachmentFiles onFileUploaded={onFileUploaded} />
                        </div>
                      )}
                      <div className="comments_section">
                        <Comments comments={commentHistory} remarks={leadData && leadData.remarks} />
                      </div>
                      <div className="action_btn_group">
                        <Button variant="outlinebtn" disabled={status && status.disabledAction} onClick={onCancel}>
                          Cancel
                        </Button>
                        <Button onClick={onSubmit} disabled={isSubmitDisabled()}>
                          Submit Price
                          {loader && <span className="loading_icon"></span>}
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-footer">
                    <div className="info_strip">
                      <div className={`info_text ${status && status.cssClass}`}>Status: {status && status.message}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PlanPricingLoader />
      )}
    </React.Fragment>
  );
};
